import lodash from 'lodash';
import momentLib from 'moment';

export const _ = lodash;
export const moment = momentLib;
